import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getIdentityRegionaleRequest: ['loading'],
    getIdentityRegionaleSuccess: ['response'],
    getIdentityRegionaleFailure: ['error'],
})

export const getIdentityRegionaleTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getIdentityRegionaleRequest = state => {
    return state.merge({ success: null })
}

const getIdentityRegionaleSuccess = (state, { response }) => {
    return state.merge({
        success: true,
        error: false,
        response: response.data.data,
    })
}

const getIdentityRegionaleFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_IDENTITY_REGIONALE_REQUEST]: getIdentityRegionaleRequest,
    [Types.GET_IDENTITY_REGIONALE_SUCCESS]: getIdentityRegionaleSuccess,
    [Types.GET_IDENTITY_REGIONALE_FAILURE]: getIdentityRegionaleFailure,
})
